export default {
  CHILE: 'Chile',
}
